/** Tailwind `lg` — dual fixed bars below this width (phones + tablets). */
export const COMPACT_NAV_PX = 1024;

export const NAVBAR = {
  maxWidth: "max-w-maxwidth",
  horizontalPadding: "px-[5%]",
  zIndex: {
    dock: "z-40",
    menuBackdrop: "z-[45]",
    menuShutter: "z-[48]",
    topBar: "z-50",
  },
} as const;

/** Fixed top row on compact viewports (logo + actions) — no full-width bar background. */
export const navTopBarClass = [
  "fixed inset-x-0 top-0",
  NAVBAR.zIndex.topBar,
  NAVBAR.horizontalPadding,
  "py-3",
  "bg-transparent",
  "pt-[max(0.75rem,env(safe-area-inset-top))]",
  "lg:hidden",
].join(" ");

/** Bottom dock shell on compact; single top row on desktop — no full-width bar background. */
export const navDockClass = [
  "fixed inset-x-0",
  NAVBAR.zIndex.dock,
  NAVBAR.horizontalPadding,
  "py-3",
  "bg-transparent",
  "bottom-0",
  "pb-[max(0.75rem,env(safe-area-inset-bottom))]",
  "lg:bottom-auto lg:top-0 lg:pb-3",
].join(" ");

/** Drawer + backdrop span from the top of the screen (top bar layers above). */
export const navMenuFromTopClass = "top-0";

/** Backdrop: full height above the bottom dock only. */
export const navMenuBackdropClass = `${navMenuFromTopClass} bottom-[var(--nav-mobile-bottom)]`;

/** Top bar surface when the menu drawer is open. */
export const navTopBarOpenClass = "bg-background";

export const NAV_MOBILE_TOP_BAR_ID = "nav-mobile-top-bar";
